import { useAuth } from "@/contexts/AuthContext";
import AdminQueue from "@/pages/AdminQueue";
import AdminBrokerDirectoryPage from "@/pages/AdminBrokerDirectoryPage";

function normalizeRole(r) { return r === "admin" ? "super_admin" : r; }

/**
 * Role-aware admin dashboard index.
 *   super_admin / verifier → verification queue + KPI bento
 *   support                → broker directory
 *
 * The `must_change_password` gate lives in AdminLayout so it covers
 * every admin sub-route, not just this index.
 */
export default function AdminIndexRouter() {
  const { user } = useAuth();
  const role = normalizeRole(user?.role);
  if (role === "support") return <AdminBrokerDirectoryPage />;
  return <AdminQueue />;
}
